var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a;
import { jsxs, jsx } from "react/jsx-runtime";
import { Component } from "react";
import PropTypes from "prop-types";
import * as time from "d3-time";
import { withTheme } from "styled-components";
import AxisTicks from "./AxisTicks.esm.js";
import AxisLine from "./AxisLine.esm.js";
import Label from "./Label.esm.js";
const XAxis = withTheme(
  // eslint-disable-next-line zillow/react/prefer-stateless-function
  (_a = class extends Component {
    render() {
      const {
        xAxisClassName,
        xAxisOffset,
        height,
        xAxisTickCount,
        xAxisTickInterval,
        xOrient,
        margins,
        width,
        tickFormatting,
        tickStroke = this.props.theme.constellation.colors.textDark,
        tickTextStroke,
        tickSize,
        xScale,
        stroke
      } = this.props;
      const t = `translate(0 ,${xAxisOffset + height})`;
      let tickArguments;
      if (typeof xAxisTickCount !== "undefined") {
        tickArguments = [xAxisTickCount];
      }
      if (typeof xAxisTickInterval !== "undefined") {
        tickArguments = [time[xAxisTickInterval.unit], xAxisTickInterval.interval];
      }
      return /* @__PURE__ */ jsxs("g", { className: xAxisClassName, transform: t, children: [
        /* @__PURE__ */ jsx(Label, { label: "", offset: 10, orient: xOrient, margins, width }),
        /* @__PURE__ */ jsx(AxisTicks, { tickFormatting, tickArguments, tickStroke, tickTextStroke, innerTickSize: tickSize, scale: xScale, orient: xOrient }),
        /* @__PURE__ */ jsx(AxisLine, { scale: xScale, stroke, orient: xOrient, outerTickSize: tickSize, ...this.props })
      ] });
    }
  }, __publicField(_a, "propTypes", {
    fill: PropTypes.string,
    height: PropTypes.number.isRequired,
    stroke: PropTypes.string,
    strokeWidth: PropTypes.string,
    tickStroke: PropTypes.string,
    xAxisClassName: PropTypes.string,
    xAxisOffset: PropTypes.number,
    xScale: PropTypes.func.isRequired,
    xOrient: PropTypes.oneOf(["top", "bottom"]),
    xAxisTickCount: PropTypes.number,
    xAxisTickInterval: PropTypes.number,
    // eslint-disable-next-line zillow/react/forbid-prop-types
    margins: PropTypes.object,
    width: PropTypes.number,
    tickFormatting: PropTypes.func,
    tickTextStroke: PropTypes.string,
    tickSize: PropTypes.number,
    // eslint-disable-next-line zillow/react/forbid-prop-types
    theme: PropTypes.object
  }), __publicField(_a, "defaultProps", {
    fill: "none",
    stroke: "none",
    strokeWidth: "none",
    xAxisClassName: "rd3-x-axis",
    xAxisOffset: 0,
    xOrient: "bottom"
  }), _a)
);
export {
  XAxis as default
};
